import './index.css'
import { boot } from './services/boot'
import { App } from './app'

boot().then((services) => {
  const root = document.getElementById('root')!;
  const app = new App(root, services);
  app.init();
});
